import React, { useEffect,useState } from 'react'

import styled from 'styled-components'
import { Link } from 'react-router-dom';


function Footer() {

 
  return (
    <>
        <footer id="footer">
        <div className="footer-main">
        <div className="container">
            <div className="row">
            <div className="footer-logo">
                <div className="logo_footer">
                <img src="/assets/images/logo.png" alt="" />
                </div>
                <p>Altcoinator is the erc20 token creation Dapp. It allows you to create your own erc20 token without writing any code.</p>
            </div>
            <div className="widget support">
                <h5 className="widget-title">
                About
                </h5>
                <ul className="widget-link">
                <li>
                    <a target={"_blank"} href="https://altcoinator.gitbook.io/docs">Documents</a>
                </li>
                <li>
                <a href="#" data-toggle="modal" data-target="#popup_bid">Terms of Use</a>
                </li>
                </ul>
            </div>
             
            </div>
        </div>
        </div>
        <div className="footer-bottom">
        <div className="container">
            <div className="wrap-fx">
            <div className="Copyright">
                Copyright © 2024 Altcoinator
            </div>
            <ul className="social">
                <li>
                <a href="https://twitter.com/altcoinatorcom">
                    <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_157_2529)">
                        <path d="M18 3.41887C17.3306 3.7125 16.6174 3.90712 15.8737 4.00162C16.6388 3.54487 17.2226 2.82712 17.4971 1.962C16.7839 2.38725 15.9964 2.68763 15.1571 2.85525C14.4799 2.13413 13.5146 1.6875 12.4616 1.6875C10.4186 1.6875 8.77387 3.34575 8.77387 5.37863C8.77387 5.67113 8.79862 5.95237 8.85938 6.22012C5.7915 6.0705 3.07687 4.60013 1.25325 2.36025C0.934875 2.91263 0.748125 3.54488 0.748125 4.2255C0.748125 5.5035 1.40625 6.63637 2.38725 7.29225C1.79437 7.281 1.21275 7.10888 0.72 6.83775C0.72 6.849 0.72 6.86363 0.72 6.87825C0.72 8.6715 1.99912 10.161 3.6765 10.5041C3.37612 10.5863 3.04875 10.6256 2.709 10.6256C2.47275 10.6256 2.23425 10.6121 2.01038 10.5626C2.4885 12.024 3.84525 13.0984 5.4585 13.1332C4.203 14.1154 2.60888 14.7071 0.883125 14.7071C0.5805 14.7071 0.29025 14.6936 0 14.6565C1.63462 15.7106 3.57188 16.3125 5.661 16.3125C12.4515 16.3125 16.164 10.6875 16.164 5.81175C16.164 5.64862 16.1584 5.49113 16.1505 5.33475C16.8829 4.815 17.4982 4.16587 18 3.41887Z" fill="#798DA3" />
                    </g>
                    <defs>
                        <clipPath id="clip0_157_2529">
                        <rect width={18} height={18} fill="white" />
                        </clipPath>
                    </defs>
                    </svg>
                </a>
                </li>                
            </ul>
            </div>
        </div>
        </div>
        </footer>  
    </>
  );
}

export default Footer;




